import React from "react";
import { createPortal } from "react-dom";
import { formatRupiah } from "../../../../../helper/formatNumber";
import { formatDateTransactionDetail } from "../../../../../helper/formatDate";

const ModalDetailPharmacySales = ({
  isShowModal,
  onCloseModal,
  pharmacyTransaction,
}) => {
  return createPortal(
    isShowModal && (
      <div className="modal-product-container">
        <div className="modal-product-content">
          <header className="modal-product-header">
            <h2 className="modal-product-header-title">Detail Transaksi</h2>
            <button
              className="modal-header-close-button"
              onClick={() => onCloseModal()}
            >
              &times;
            </button>
          </header>
          <main className="modal-product-main">
            <p style={{ margin: 0, padding: 0 }}>
              Tanggal Transaksi:{" "}
              {formatDateTransactionDetail(
                pharmacyTransaction.product_transaction_date
              )}
            </p>
            <p style={{ margin: 0, padding: 0 }}>
              Pasien: {pharmacyTransaction.patient_name}
            </p>
            <p style={{ margin: 0, padding: 0 }}>
              Dokter: {pharmacyTransaction.doctor_name}
            </p>
            <div className="product-table-container">
              <table className="product-table">
                <thead>
                  <tr>
                    <th width="50px">No</th>
                    <th>Obat</th>
                    <th>Jumlah</th>
                    <th>Harga Satuan</th>
                    <th>Total Transaksi</th>
                  </tr>
                </thead>
                <tbody>
                  {pharmacyTransaction.product_transaction_data.map(
                    (transaction, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: transaction.is_prescription
                            ? "red"
                            : "blue",
                          color: "white", // Ensuring text is visible
                        }}
                      >
                        <td>{index + 1}</td>
                        <td>{transaction.product_transaction_name}</td>
                        <td>{transaction.product_transaction_quantity}</td>
                        <td>
                          {formatRupiah(
                            transaction.product_transaction_per_item_price
                          )}
                        </td>
                        <td>
                          {formatRupiah(transaction.product_transaction_price)}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </main>
          <footer className="modal-product-footer">
            <div style={{ margin: "10px 0", fontSize: "14px" }}>
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "15px",
                    height: "15px",
                    backgroundColor: "blue",
                    marginRight: "5px",
                  }}
                ></div>
                OTC
                <div
                  style={{
                    width: "15px",
                    height: "15px",
                    backgroundColor: "red",
                    marginRight: "5px",
                    marginLeft: "8px",
                  }}
                ></div>
                Resep
              </span>
            </div>
            <button
              className="modal-close-button"
              onClick={() => onCloseModal()}
            >
              Tutup
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalDetailPharmacySales;
